module.exports = __webpack_public_path__ + "static/media/40x40-1.c689bfed.png";